import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { QuoteFlowModeEnum } from '@jove-frontend/enums';
import { NameInDifferentCountriesEnum, getTheNameTextInDifferentCountries } from '../constants';
import { PROFESSIONAL_INDEMNITY, PUBLIC_LIABILITY } from '../constants/coverage';
import { GidInsuranceBundleAll, GidInsuranceBundleListOnly, PROVIDER_SOURCE } from '../constants/quote';
import { BrokerPaymentBillTypeEnum, InsuranceType } from '../shared/generated';
import { getLocalTranslation } from '../utils/i18nKit';
import { getCoverInfoMapWithExtraConfig } from './coverage';
export var GoodsInTransitKey = 'goods-in-transit';
export var businessInsuranceKey = 'business-insurance';
export var hiredInPlantKey = 'hired-in-plant';
export var goodsInTransitOldCompatibilityKey = 'goods-in-transit-insurance';
export var constructionInsuranceKey = 'construction-insurance';
export var getBusinessInsuranceTypes = function getBusinessInsuranceTypes() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return [{
    label: $t('kit:business_insurance'),
    value: businessInsuranceKey,
    description: $t('kit:business_insurance_desc')
  }, {
    label: $t('kit:construction_insurance'),
    value: hiredInPlantKey,
    description: $t('kit:construction_insurance_desc')
  }, {
    label: $t('kit:goods_in_transit_insurance'),
    value: GoodsInTransitKey,
    description: $t('kit:goods_in_transit_insurance_desc')
  }];
};
export var gitBusinessActivityCourier = 'BCS-047';
export var gitBusinessActivityRemovals = 'BCS-286';
export var gitBusinessActivityVehicleTransportation = 'BCS-287';
export var gitBusinessActivityVehicleTransportationAndRemovals = 'BCS-289'; // Declaration question IDs

export var GIT_DECLARATION_ID = 'goods_in_transit_declaration_p1';
export var GREAT_AMERICAN_DECLARATION_P1 = 'greate_american_declaration_p1';
export var GREAT_AMERICAN_FAST_PROCESS_DECLARATION_P1 = 'great_american_fast_process_declaration';
export var RECRUITMENT_DECLARATION = 'recruitment_declaration_p1';
export var GREAT_AMERICAN_BUSINESS_INSURANCE_DECLARATION = 'great_american_business_insurance_declaration_p1';
export var HISCOX_DECLARATION = 'hiscox_declaration_p1';
export var getInsurerTypeMap = function getInsurerTypeMap() {
  var _ref;

  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  return _ref = {}, _defineProperty(_ref, businessInsuranceKey, {
    label: $t('kit:business_insurance'),
    value: businessInsuranceKey
  }), _defineProperty(_ref, hiredInPlantKey, {
    label: $t('kit:construction_insurance'),
    value: hiredInPlantKey
  }), _defineProperty(_ref, goodsInTransitOldCompatibilityKey, {
    label: $t('kit:goods_in_transit_insurance'),
    value: goodsInTransitOldCompatibilityKey
  }), _ref;
};
export var getInsurerTypeList = function getInsurerTypeList() {
  return Object.values(getInsurerTypeMap());
};
export var getGitFixedBusinessActivitiesMap = function getGitFixedBusinessActivitiesMap() {
  var _ref2;

  var _getLocalTranslation3 = getLocalTranslation(),
      $t = _getLocalTranslation3.$t;

  return _ref2 = {}, _defineProperty(_ref2, gitBusinessActivityCourier, {
    value: gitBusinessActivityCourier,
    label: $t('kit:courier'),
    content: "".concat($t('kit:single_furniture_items_delivery_seller_to_buyer_acceptable'), "."),
    icon: '',
    questionId: 'question_good_in_transit_couriers'
  }), _defineProperty(_ref2, gitBusinessActivityVehicleTransportation, {
    value: gitBusinessActivityVehicleTransportation,
    label: $t('kit:vehicle_transportation'),
    content: "".concat($t('kit:single_furniture_items_delivery_seller_to_buyer_acceptable'), "."),
    icon: '',
    questionId: 'question_good_in_transit_vehicle_transportations'
  }), _defineProperty(_ref2, gitBusinessActivityRemovals, {
    value: gitBusinessActivityRemovals,
    label: $t('kit:house_removals'),
    content: "".concat($t('kit:single_furniture_items_delivery_seller_to_buyer_acceptable'), "."),
    icon: '',
    questionId: 'question_good_in_transit_removers'
  }), _defineProperty(_ref2, gitBusinessActivityVehicleTransportationAndRemovals, {
    value: gitBusinessActivityVehicleTransportationAndRemovals,
    label: $t('kit:vehicle_transportation_and_removals'),
    content: "".concat($t('kit:single_furniture_items_delivery_seller_to_buyer_acceptable'), "."),
    icon: '',
    questionId: 'question_good_in_transit_vehicle_transportation_and_removers'
  }), _ref2;
};
export var getGitFixedBusinessActivities = function getGitFixedBusinessActivities() {
  return Object.values(getGitFixedBusinessActivitiesMap());
};
export var getGitInsuranceBundleList = function getGitInsuranceBundleList() {
  var _getLocalTranslation4 = getLocalTranslation(),
      $t = _getLocalTranslation4.$t;

  return [{
    value: GidInsuranceBundleAll,
    label: $t('kit:goods_in_transit_liability_bundle'),
    money: 110.88
  }, {
    value: GidInsuranceBundleListOnly,
    label: $t('kit:goods_in_transit_only'),
    icon: '',
    money: 56.04
  }];
};
export var DeclarationsOptionsMapKeyEnum;

(function (DeclarationsOptionsMapKeyEnum) {
  DeclarationsOptionsMapKeyEnum["agreeKey"] = "1";
  DeclarationsOptionsMapKeyEnum["yesOrNoKey"] = "2";
})(DeclarationsOptionsMapKeyEnum || (DeclarationsOptionsMapKeyEnum = {}));

export var getDeclarationsOptionsMap = function getDeclarationsOptionsMap() {
  var _getLocalTranslation5 = getLocalTranslation(),
      $t = _getLocalTranslation5.$t;

  return {
    '1': [{
      label: $t('kit:i_disagree'),
      value: 'I disagree',
      truelyValue: false,
      capitalLabel: 'I DISAGREE',
      yesOrNoCapitalLabel: 'NO',
      yesOrNoLowerCaseLabel: 'no'
    }, {
      label: $t('kit:i_agree'),
      value: 'I agree',
      truelyValue: true,
      capitalLabel: 'I AGREE',
      yesOrNoCapitalLabel: 'YES',
      yesOrNoLowerCaseLabel: 'yes'
    }],
    '2': [{
      label: $t('kit:no'),
      value: 'No',
      truelyValue: false,
      capitalLabel: 'NO',
      yesOrNoCapitalLabel: 'NO',
      yesOrNoLowerCaseLabel: 'no'
    }, {
      label: $t('kit:yes'),
      value: 'Yes',
      truelyValue: true,
      capitalLabel: 'YES',
      yesOrNoCapitalLabel: 'YES',
      yesOrNoLowerCaseLabel: 'yes'
    }],
    '3': [{
      label: 'Exclude',
      value: 'No',
      truelyValue: false,
      capitalLabel: 'EXCLUDE',
      yesOrNoCapitalLabel: 'EXCLUDE',
      yesOrNoLowerCaseLabel: 'exclude'
    }, {
      label: 'Include',
      value: 'Yes',
      truelyValue: true,
      capitalLabel: 'INCLUDE',
      yesOrNoCapitalLabel: 'INCLUDE',
      yesOrNoLowerCaseLabel: 'include'
    }]
  };
}; // annual type

export var ANNUAL_KEY = 'annual';
export var ANNUAL_FLEXIBLE_KEY = 'annual_flexible';
export var CONTRACT_SPECIFIC_KEY = 'contract_specific';
export var getAnnualTypeMap = function getAnnualTypeMap() {
  var _ref3;

  var _getLocalTranslation6 = getLocalTranslation(),
      $t = _getLocalTranslation6.$t;

  return _ref3 = {}, _defineProperty(_ref3, ANNUAL_FLEXIBLE_KEY, {
    value: ANNUAL_FLEXIBLE_KEY,
    label: $t('kit:annual_flexible'),
    abbrLabel: $t('kit:annual_flexible'),
    infoLabel: $t('kit:annual_flexible'),
    order: 1
  }), _defineProperty(_ref3, CONTRACT_SPECIFIC_KEY, {
    value: CONTRACT_SPECIFIC_KEY,
    label: $t('kit:contract_specific'),
    abbrLabel: $t('kit:contract'),
    infoLabel: $t('kit:contract_specific'),
    order: 2
  }), _defineProperty(_ref3, ANNUAL_KEY, {
    value: ANNUAL_KEY,
    label: $t('kit:annual'),
    abbrLabel: $t('kit:annual'),
    infoLabel: $t('kit:annual'),
    order: 3
  }), _ref3;
};
export var getAnnualTypeList = function getAnnualTypeList() {
  return Object.values(getAnnualTypeMap());
};
/**
 * Deduction method
 */

export var getDeductionMethodMap = function getDeductionMethodMap(providerCode) {
  var _getLocalTranslation7 = getLocalTranslation(),
      $t = _getLocalTranslation7.$t;

  var deductionMethodMap = {
    monthly: {
      value: 'monthly',
      label: $t('kit:monthly')
    },
    annual: {
      value: 'annual',
      label: $t('kit:annual')
    }
  }; // quarterly & semi-annual deduction methods are only available for Hiscox US quotes

  if (providerCode === PROVIDER_SOURCE().HISCOX_US.value) {
    deductionMethodMap.quarterly = {
      value: 'quarterly',
      label: 'Quarterly'
    };
    deductionMethodMap.semiAnnual = {
      value: 'semi_annual',
      label: 'Semi-Annual'
    };
  }

  return deductionMethodMap;
};
export var getDeductionMethodList = function getDeductionMethodList(providerCode) {
  return Object.values(getDeductionMethodMap(providerCode));
}; // Business type

export var BusinessTypeSoleTrader = 'BT-001';
export var BusinessTypeLimitedCompany = 'BT-002';
export var BusinessTypePartnershipCompany = 'BT-003';
export var BusinessTypeLimitedLiabilityCompany = 'BT-009';
export var BusinessTypeNotSelectedOther = 'unique-unselected-other';
export var BusinessTypeSoleProprietor = 'Sole Proprietor';
export var businessTypeList = [{
  value: BusinessTypeSoleTrader,
  label: 'Sole Trader',
  displayLabel: 'trading'
}, {
  value: BusinessTypeLimitedCompany,
  label: 'Limited Company',
  displayLabel: 'company'
}, {
  value: BusinessTypePartnershipCompany,
  label: 'Partnership',
  displayLabel: 'partnership'
}, {
  value: BusinessTypeNotSelectedOther,
  label: 'Other',
  displayLabel: 'Other'
}];
export var otherBusinessTypeList = [{
  value: 'BT-004',
  label: 'Charity'
}, {
  value: 'BT-005',
  label: 'Club'
}, {
  value: 'BT-006',
  label: 'LLP'
}, {
  value: 'BT-007',
  label: 'Public Organisation'
}, {
  value: 'BT-008',
  label: 'Society'
}];
export var getBusinessTypeList = function getBusinessTypeList(config) {
  var _getLocalTranslation8 = getLocalTranslation(),
      $t = _getLocalTranslation8.$t;

  return [{
    value: BusinessTypeSoleTrader,
    label: getTheNameTextInDifferentCountries(NameInDifferentCountriesEnum.soleTrader, config === null || config === void 0 ? void 0 : config.country, {
      defaultText: $t('kit:sole-trader')
    }),
    displayLabel: 'trading'
  }, {
    value: BusinessTypeLimitedCompany,
    label: getTheNameTextInDifferentCountries(NameInDifferentCountriesEnum.limitedCompany, config === null || config === void 0 ? void 0 : config.country, {
      defaultText: $t('kit:limited-company')
    }),
    displayLabel: 'company'
  }, {
    value: BusinessTypePartnershipCompany,
    label: getTheNameTextInDifferentCountries(NameInDifferentCountriesEnum.limitedLiabilityPartnership, config === null || config === void 0 ? void 0 : config.country, {
      defaultText: $t('kit:partnership')
    }),
    displayLabel: 'partnership'
  }, {
    value: BusinessTypeNotSelectedOther,
    label: $t('kit:other'),
    displayLabel: 'Other'
  }];
};
export var getGreatAmericanBusinessInsuranceBusinessTypeList = function getGreatAmericanBusinessInsuranceBusinessTypeList() {
  return [{
    value: BusinessTypeSoleProprietor,
    label: 'Sole Proprietor',
    displayLabel: 'Sole Proprietor'
  }, {
    value: 'Corporation',
    label: 'Corporation',
    displayLabel: 'Corporation'
  }, {
    value: 'LLC',
    label: 'LLC',
    displayLabel: 'LLC'
  }];
};
export var getGreatAmericanBusinessInsuranceOtherBusinessTypeList = function getGreatAmericanBusinessInsuranceOtherBusinessTypeList() {
  return [{
    value: 'INC',
    label: 'INC',
    displayLabel: 'INC'
  }, {
    value: 'LLP',
    label: 'LLP',
    displayLabel: 'LLP'
  }, {
    value: 'LP',
    label: 'LP',
    displayLabel: 'LP'
  }, {
    value: 'Joint Venture',
    label: 'Joint Venture',
    displayLabel: 'Joint Venture'
  }, {
    value: 'Nonprofit Organization',
    label: 'Nonprofit Organization',
    displayLabel: 'Nonprofit Organization'
  }, {
    value: 'Trust',
    label: 'Trust',
    displayLabel: 'Trust'
  }, {
    value: 'Estate',
    label: 'Estate',
    displayLabel: 'Estate'
  }, {
    value: 'professional_association',
    label: 'Professional Association',
    displayLabel: 'Professional Association'
  }, {
    value: 'other',
    label: 'Other',
    displayLabel: 'Other'
  }];
};
export var getOtherBusinessTypeList = function getOtherBusinessTypeList(providerCode, config) {
  var _getLocalTranslation9 = getLocalTranslation(),
      $t = _getLocalTranslation9.$t;

  var list = [{
    value: 'BT-008',
    label: $t('kit:association')
  }, {
    value: 'BT-004',
    label: $t('kit:charity')
  }, {
    value: 'BT-005',
    label: $t('kit:club')
  }];

  if (['PT'].includes(config === null || config === void 0 ? void 0 : config.country)) {
    list.push({
      value: 'BT-002-2',
      label: $t('kit:sole_shareholder_limited_company')
    });
  } else {
    list.push({
      value: 'BT-007',
      label: $t('kit:public_limited')
    });
  }

  return list;
};
export var getAllBusinessTypeMap = function getAllBusinessTypeMap() {
  var map = {};
  [].concat(_toConsumableArray(getBusinessTypeList()), _toConsumableArray(getOtherBusinessTypeList()), _toConsumableArray(getGreatAmericanBusinessInsuranceBusinessTypeList()), _toConsumableArray(getGreatAmericanBusinessInsuranceOtherBusinessTypeList())).forEach(function (item) {
    map[item.value] = _objectSpread({}, item);
  });
  return map;
};
export var getDocumentSupportTranslationCountriesMap = function getDocumentSupportTranslationCountriesMap() {
  return {
    GB: {
      code: 'EN',
      name: 'United Kingdom',
      countryCode: 'GB'
    },
    BG: {
      code: 'BG',
      name: 'Bulgarian',
      countryCode: 'BG'
    },
    CZ: {
      code: 'CS',
      countryCode: 'CZ',
      name: 'Czech'
    },
    DK: {
      code: 'DA',
      countryCode: 'DK',
      name: 'Danish'
    },
    NL: {
      code: 'NL',
      name: 'Dutch',
      countryCode: 'NL'
    },
    ET: {
      code: 'ET',
      name: 'Estonian',
      countryCode: 'ET'
    },
    FI: {
      code: 'FI',
      name: 'Finnish',
      countryCode: 'FI'
    },
    FR: {
      code: 'FR',
      name: 'French',
      countryCode: 'FR'
    },
    DE: {
      code: 'DE',
      name: 'German',
      countryCode: 'DE'
    },
    GR: {
      code: 'EL',
      countryCode: 'GR',
      name: 'Greek'
    },
    HU: {
      code: 'HU',
      name: 'Hungarian',
      countryCode: 'HU'
    },
    IT: {
      code: 'IT',
      name: 'Italian',
      countryCode: 'IT'
    },
    LV: {
      code: 'LV',
      name: 'Latvian',
      countryCode: 'LV'
    },
    LT: {
      code: 'LT',
      name: 'Lithuanian',
      countryCode: 'LT'
    },
    NO: {
      code: 'NO',
      name: 'Norwegian',
      countryCode: 'NO'
    },
    PL: {
      code: 'PL',
      name: 'Polish',
      countryCode: 'PL'
    },
    PT: {
      code: 'PT',
      name: 'Portuguese',
      countryCode: 'PT'
    },
    RO: {
      code: 'RO',
      name: 'Romanian',
      countryCode: 'RO'
    },
    SK: {
      code: 'SK',
      name: 'Slovak',
      countryCode: 'SK'
    },
    SL: {
      code: 'SL',
      name: 'Slovenian',
      countryCode: 'SL'
    },
    ES: {
      code: 'ES',
      name: 'Spanish',
      countryCode: 'ES'
    },
    SV: {
      code: 'SV',
      name: 'Swedish',
      countryCode: 'SV'
    }
  };
};
export var getDocumentSupportTranslationCountryList = Object.values(getDocumentSupportTranslationCountriesMap()).map(function (item) {
  return _objectSpread(_objectSpread({}, item), {}, {
    value: item.countryCode,
    label: item
  });
});
export var getQuoteRenewStatusMap = function getQuoteRenewStatusMap() {
  var _getLocalTranslation10 = getLocalTranslation(),
      $t = _getLocalTranslation10.$t;

  return {
    notYet: {
      value: 'not_yet',
      label: $t('kit:renewStatus.not_yet')
    },
    renewSoon: {
      value: 'renew_soon',
      label: $t('kit:renewStatus.renew_soon')
    },
    renewed: {
      value: 'renewed',
      label: $t('kit:.renewStatus.renewed')
    }
  };
};
export var getQuoteRenewStatusList = function getQuoteRenewStatusList() {
  return Object.values(getQuoteRenewStatusMap());
};
export var getQuoteFlowModeMap = function getQuoteFlowModeMap() {
  var _getLocalTranslation11 = getLocalTranslation(),
      $t = _getLocalTranslation11.$t;

  return {
    normal: {
      value: QuoteFlowModeEnum.normal,
      label: $t('kit:flowMode.normal')
    },
    fastTrack: {
      value: QuoteFlowModeEnum.fastTrack,
      label: $t('kit:flowMode.fastTrack')
    }
  };
};
export var getQuoteFlowModeList = function getQuoteFlowModeList() {
  return Object.values(getQuoteFlowModeMap());
};
export var getQuoteProductTypeList = function getQuoteProductTypeList(insuranceType) {
  if (insuranceType === InsuranceType.BUSINESS_INSURANCE) {
    return [{
      value: 'sme',
      label: 'SME'
    }, {
      value: 'recruitmentScheme',
      label: 'Recruitment Scheme'
    }, {
      value: 'commercialScheme',
      label: 'Commercial Scheme'
    }];
  } else if (insuranceType === InsuranceType.GOODS_IN_TRANSIT_INSURANCE) {
    return [{
      value: 'courier',
      label: 'Courier'
    }, {
      value: 'householdRemoval',
      label: 'Household Removal'
    }];
  } else {
    return [];
  }
};
export var getQuoteInsuranceCompaniesMap = function getQuoteInsuranceCompaniesMap() {
  return {
    greatAmerican: {
      value: 'greatAmerican',
      label: 'Great American'
    },
    accelerant: {
      value: 'accelerant',
      label: 'Accelerant'
    }
  };
};
export var getQuoteInsuranceCompaniesList = function getQuoteInsuranceCompaniesList() {
  return Object.values(getQuoteInsuranceCompaniesMap());
};
export var getQuotePaymentBillTypeMap = function getQuotePaymentBillTypeMap() {
  var _getLocalTranslation12 = getLocalTranslation(),
      $t = _getLocalTranslation12.$t;

  return {
    jove: {
      value: BrokerPaymentBillTypeEnum.JOVE_BILLING,
      label: $t('kit:jove_bill')
    },
    agency: {
      value: BrokerPaymentBillTypeEnum.AGENT_BILLING,
      label: $t('kit:agency_bill')
    },
    bankTransfer: {
      value: BrokerPaymentBillTypeEnum.BANK_TRANSFER,
      label: $t('kit:bank_transfer')
    },
    directDebit: {
      value: BrokerPaymentBillTypeEnum.DIRECT_DEBIT,
      label: $t('kit:direct_debit')
    }
  };
};
export var getQuotePaymentBillTypeList = function getQuotePaymentBillTypeList() {
  return Object.values(getQuotePaymentBillTypeMap());
};
export var getBusinessInsuranceOldCompatibilityTypeList = function getBusinessInsuranceOldCompatibilityTypeList() {
  var _getLocalTranslation13 = getLocalTranslation(),
      $t = _getLocalTranslation13.$t;

  return [{
    label: $t('kit:business_insurance'),
    value: businessInsuranceKey,
    description: $t('kit:business_insurance_desc')
  }, {
    label: $t('kit:construction_insurance'),
    value: constructionInsuranceKey,
    desc: $t('kit:construction_insurance_desc')
  }, {
    label: $t('kit:goods_in_transit_insurance'),
    value: goodsInTransitOldCompatibilityKey,
    description: $t('kit:goods_in_transit_insurance_desc')
  }];
};
export var getGreatAmericanInsuranceBundleMap = function getGreatAmericanInsuranceBundleMap() {
  var coverMap = getCoverInfoMapWithExtraConfig({
    countryCode: 'US'
  });
  return {
    piAndPl: {
      value: 'pl_gl_only',
      label: "".concat(coverMap[PROFESSIONAL_INDEMNITY].label, " & ").concat(coverMap[PUBLIC_LIABILITY].label)
    },
    piAndBopCyber: {
      value: 'pl_bop_cyber',
      label: 'Comprehensive Bundle'
    }
  };
};
export var getGreatAmericanInsuranceBundleList = function getGreatAmericanInsuranceBundleList() {
  return Object.values(getGreatAmericanInsuranceBundleMap());
};